"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapCreator = void 0;
var MapCreator = (function () {
    function MapCreator(result) {
        if (result === void 0) { result = {}; }
        this.result = result;
    }
    MapCreator.prototype.add = function (key, value) {
        this.result[key] = value;
        return this;
    };
    MapCreator.prototype.append = function (map) {
        for (var key in map)
            if (Object.prototype.hasOwnProperty.call(map, key))
                this.result[key] = map[key];
        return this;
    };
    MapCreator.prototype.getByKey = function (key) {
        return this.result[key];
    };
    MapCreator.prototype.get = function () {
        return this.result;
    };
    return MapCreator;
}());
exports.MapCreator = MapCreator;
